import { Container, Row, Col, Card, Modal, Button } from "react-bootstrap";
import { useState } from 'react';
import { Package, PlayCircle, ExternalLink, Download, X, ChevronRight, Sparkles } from 'lucide-react';
import img1 from '../../assets/img/noticias/prod-nuevos.png';
import img2 from '../../assets/img/noticias/socios-comerciales.png';
import catalogoTruper from '../../assets/pdf/CatalogoTruper.pdf';

const noticias = [
    {
        id: 1,
        titulo: "Noticias y Novedades",
        descripcion: "Descubre las últimas noticias, lanzamientos de productos y eventos relacionados con Salcedo Importaciones S.R.L. Mantente al día con nuestras novedades y ofertas exclusivas.",
        imagen: img1,
        icon: <Package size={40} />,
        color: "#fe5000",
        badge: "Nuevo",
        link: "/noticias_novedades",
        action: "link"
    },
    {
        id: 2,
        titulo: "Videos Informativos",
        descripcion: "Tutoriales, guías y demostraciones de productos. Aprende cómo sacar el máximo provecho a tus herramientas.",
        imagen: img2,
        icon: <PlayCircle size={40} />,
        color: "#fe5000",
        badge: "Popular",
        link: "/videos_novedades",
        action: "link"
    },
    
];

function Noticias() {
    const [showModal, setShowModal] = useState(false);
    const [selectedMarca, setSelectedMarca] = useState(null);
    const [hoveredCard, setHoveredCard] = useState(null);

    const handleCardClick = (noticia) => {
        if (noticia.action === "modal") {
            setSelectedMarca(noticia);
            setShowModal(true);
        } else if (noticia.action === "link" && noticia.link) {
            if (noticia.link.startsWith('http')) {
                window.open(noticia.link, '_blank', 'noopener,noreferrer');
            } else {
                window.location.href = noticia.link;
            }
        }
    };

    const handleClose = () => {
        setShowModal(false);
        setSelectedMarca(null);
    };

    return (
        <>
            <div class="ticker-band">
                <div class="ticker-inner">
                    <span class="ticker-item">Herramientas Manuales</span>
                    <span class="ticker-item">Herramientas Eléctricas</span>
                    <span class="ticker-item">Equipos de Construcción</span>
                    <span class="ticker-item">Mecánica y Automotriz</span>
                    <span class="ticker-item">Ferretería Especializada</span>
                    <span class="ticker-item">Distribuidor Oficial Truper</span>
                    <span class="ticker-item">Sacaba, Bolivia</span>
                    <span class="ticker-item">Venta Mayorista</span>
                    <span class="ticker-item">Herramientas Manuales</span>
                    <span class="ticker-item">Herramientas Eléctricas</span>
                    <span class="ticker-item">Equipos de Construcción</span>
                    <span class="ticker-item">Mecánica y Automotriz</span>
                    <span class="ticker-item">Ferretería Especializada</span>
                    <span class="ticker-item">Distribuidor Oficial Truper</span>
                    <span class="ticker-item">Sacaba, Bolivia</span>
                    <span class="ticker-item">Venta Mayorista</span>
                </div>
            </div>
            {/* Sección de Noticias */}
            <section id="noticias" className="noticias-section">
                {/* Fondo decorativo animado */}
                <div className="noticias-background">
                    <div className="noticias-bg-shape noticias-shape-1"></div>
                    <div className="noticias-bg-shape noticias-shape-2"></div>
                    <div className="noticias-bg-shape noticias-shape-3"></div>
                    <div className="noticias-bg-shape noticias-shape-4"></div>
                </div>

                <Container>
                    {/* Header de la sección */}
                    <div className="noticias-header text-center mb-5">
                        <div className="section-badge">
                            <Sparkles size={20} />
                            <span>Novedades</span>
                        </div>
                        <h2 className="noticias-title">
                            Últimas <span className="text-highlight">Noticias</span>
                        </h2>
                        <p className="noticias-subtitle">
                            Mantente informado sobre nuestros productos, tutoriales y novedades
                        </p>
                        <div className="title-divider"></div>
                    </div>

                    {/* Grid de Noticias */}
                    <Row className="g-4 justify-content-center">
                        {noticias.map((noticia, index) => (
                            <Col xs={12} md={6} lg={4} key={noticia.id}>
                                <Card 
                                    className={`noticia-card ${hoveredCard === noticia.id ? 'hovered' : ''}`}
                                    onClick={() => handleCardClick(noticia)}
                                    onMouseEnter={() => setHoveredCard(noticia.id)}
                                    onMouseLeave={() => setHoveredCard(null)}
                                    style={{ animationDelay: `${index * 0.1}s` }}
                                >
                                    {/* Badge */}
                                    {noticia.badge && (
                                        <div className="card-badge" style={{ backgroundColor: noticia.color }}>
                                            {noticia.badge}
                                        </div>
                                    )}

                                    {/* Imagen con overlay */}
                                    <div className="card-image-wrapper">
                                        <Card.Img 
                                            variant="top" 
                                            src={noticia.imagen}
                                            className="card-image"
                                        />
                                        <div className="card-overlay">
                                            <div className="overlay-icon" style={{ color: noticia.color }}>
                                                {noticia.icon}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Contenido */}
                                    <Card.Body className="card-body-custom">
                                        <div className="card-icon" style={{ color: noticia.color }}>
                                            {noticia.icon}
                                        </div>
                                        
                                        <h3 className="card-title-custom">
                                            {noticia.titulo}
                                        </h3>
                                        
                                        <Card.Text className="card-description">
                                            {noticia.descripcion}
                                        </Card.Text>

                                        <div className="card-footer-custom">
                                            <span className="card-link-text">
                                                {noticia.action === "modal" ? "Ver Catálogo" : "Explorar"}
                                            </span>
                                            <ChevronRight 
                                                size={20} 
                                                className="card-arrow"
                                                style={{ color: noticia.color }}
                                            />
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    {/* Call to Action adicional */}
                    <div className="noticias-cta text-center mt-5">
                        <p className="cta-text">
                            ¿Buscas más información sobre nuestros productos?
                        </p>
                        <a href="/contacto" className="btn-noticias-cta">
                            Contáctanos
                            <ExternalLink size={18} />
                        </a>
                    </div>
                </Container>
            </section>

            {/* Modal Mejorado */}
            <Modal 
                show={showModal} 
                onHide={handleClose} 
                size="xl"
                centered
                className="noticias-modal"
            >
                <Modal.Header className="modal-header-custom">
                    <Modal.Title className="modal-title-custom">
                        {selectedMarca && (
                            <div className="d-flex align-items-center gap-3">
                                <div 
                                    className="modal-icon-wrapper"
                                    style={{ backgroundColor: `${selectedMarca.color}20` }}
                                >
                                    <div style={{ color: selectedMarca.color }}>
                                        {selectedMarca.icon}
                                    </div>
                                </div>
                                <div>
                                    <h4 className="mb-0">{selectedMarca.titulo}</h4>
                                    <small className="text-muted">Catálogo de Productos</small>
                                </div>
                            </div>
                        )}
                    </Modal.Title>
                    <button 
                        className="modal-close-btn"
                        onClick={handleClose}
                    >
                        <X size={24} />
                    </button>
                </Modal.Header>
                
                <Modal.Body className="modal-body-custom">
                    {selectedMarca && (
                        <div className="pdf-container">
                            <iframe
                                src={`${catalogoTruper}#page=${selectedMarca.pageNumber || 1}`}
                                className="pdf-iframe"
                                title={`Catálogo ${selectedMarca.titulo}`}
                            />
                        </div>
                    )}
                </Modal.Body>
                
                <Modal.Footer className="modal-footer-custom">
                    <Button 
                        variant="light" 
                        onClick={handleClose}
                        className="btn-modal-secondary"
                    >
                        <X size={18} />
                        Cerrar
                    </Button>
                    <Button 
                        variant="primary" 
                        className="btn-modal-primary"
                        onClick={() => window.open(`${catalogoTruper}#page=${selectedMarca?.pageNumber || 1}`, '_blank')}
                    >
                        <ExternalLink size={18} />
                        Abrir en nueva pestaña
                    </Button>
                    <Button 
                        variant="success"
                        as="a"
                        href={catalogoTruper}
                        download="Catalogo-Completo.pdf"
                        className="btn-modal-success"
                    >
                        <Download size={18} />
                        Descargar PDF
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Noticias;